<template>
  <v-dialog
      :value="value"
      persistent
      width="600px"
  >
    <v-card>
      <v-row justify="end">
        <v-btn class="mr-6 mt-4" icon @click="handleClickNo">
          <v-icon large>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-row justify="center">
        <v-icon class="mx-auto" size="200" color="primary">mdi-alert-circle</v-icon>
      </v-row>
      <v-card-text class="pa-6 text-center" style="">
        <h1 class="primary--text mb-6">求人画面に戻ります</h1>
        <h3 class="">この画面で入力いただいた情報は保存されません。<br />
        よろしいですか？</h3>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-row justify="center" align="center" class="mb-6">
          <ActionButton width="280px" icon="none" @click="handleClickNo">プロフィール入力を続ける</ActionButton>
          <TextButton width="120px" @click="handleClickYes">求人画面に戻る</TextButton>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import ActionButton from "@/components/molecules/ActionButton";
import TextButton from "@/components/atoms/TextButton";

export default {
  mixins: [ComponentMixin],
  type: "organisms",
  name: "RenewalDialog",
  components: {TextButton, ActionButton},
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("jobs", ["job"]),
  },
  methods: {
    handleClickNo() {
      this.$emit("input", false)
    },
    handleClickYes() {
      if(
        ( this.job.side && this.user.conditionForSide !== 2 )
        || ( !this.job.side && this.user.conditionForJob !== 2)
      ){
        this.$router.push(`/jobs/${this.job.id}`)
      } else {
        this.$emit("input", false)
        this.$emit("stopEdit")
      }
    },
  }
}
</script>

<style scoped>

</style>
